export const uiDefinitionExpirationTime = 60 * 60 * 1000;
